import { createSlice } from "@reduxjs/toolkit";
import { BrandsStateProps } from "../interfaces/brands";

const initialState: BrandsStateProps = {
    list: {
        fetching: "unknown",
        data: [],
        total: 0,
        error: ""
    },
    add: {
        fetching: "unknown",
        data: [],
        error: ""
    },
    edit: {
        fetching: "unknown",
        data: [],
        error: ""
    },
    delete: {
        fetching: "unknown",
        error: ""
    }
};

const brandsSlice = createSlice({
    name: "brands",
    initialState,
    reducers: {
        getBrandsRequest: (state) => {
            state.list.fetching = "loading";
        },
        getBrandsSuccess: (state, action) => {
            state.list.fetching = "success";
            state.list.data = action.payload.brands;
            state.list.total = action.payload.total;
        },
        getBrandsFailure: (state, action) => {
            state.list.fetching = "failure";
            state.list.error = action.payload;
        },
        cleanGetBrands: (state) => {
            state.list.fetching = initialState.list.fetching;
        },
        addBrandRequest: (state) => {
            state.add.fetching = "loading";
        },
        addBrandSuccess: (state, action) => {
            state.add.fetching = "success";
            state.add.data = action.payload.brands;
        },
        addBrandFailure: (state, action) => {
            state.add.fetching = "failure";
            state.add.error = action.payload;
        },
        cleanAddBrand: (state) => {
            state.add.fetching = initialState.add.fetching;
        },
        editBrandRequest: (state) => {
            state.edit.fetching = "loading";
        },
        editBrandSuccess: (state, action) => {
            state.edit.fetching = "success";
            state.edit.data = action.payload.brands;
        },
        editBrandFailure: (state, action) => {
            state.edit.fetching = "failure";
            state.edit.error = action.payload;
        },
        cleanEditBrand: (state) => {
            state.edit.fetching = initialState.edit.fetching;
        },
        deleteBrandRequest: (state) => {
            state.delete.fetching = "loading";
        },
        deleteBrandSuccess: (state, action) => {
            state.delete.fetching = "success";
        },
        deleteBrandFailure: (state, action) => {
            state.delete.fetching = "failure";
            state.delete.error = action.payload;
        },
        cleanDeleteBrand: (state) => {
            state.delete.fetching = initialState.delete.fetching;
        }
    }
});

export const {
    getBrandsRequest,
    getBrandsSuccess,
    getBrandsFailure,
    cleanGetBrands,
    addBrandRequest,
    addBrandSuccess,
    addBrandFailure,
    cleanAddBrand,
    editBrandRequest,
    editBrandSuccess,
    editBrandFailure,
    cleanEditBrand,
    deleteBrandRequest,
    deleteBrandSuccess,
    deleteBrandFailure,
    cleanDeleteBrand
} = brandsSlice.actions;

export default brandsSlice.reducer;
